import React from 'react';
import {
    Box,
    Typography,
} from '@mui/material';
import { headerSX } from '../components/common/header-component/style-constant';

const Resources = () => {

    const cardConfigSx = {
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        borderRadius: '10px',
        boxShadow: 'rgb(159 162 191 / 18%) 0px 9px 16px, rgb(159 162 191 / 32%) 0px 2px 2px',
        alignItems: 'center',
        padding: '3rem',
        width: '70%'
    }

    const contentConfigSx = {
        margin: '0px',
        fontWeight: 300,
        lineHeight: '1.167',
        fontSize: '1.75rem'
    }

    const contentGenerator = (content) => content.map((f, index) => {
        return (
            <React.Fragment key={index}>
                <Box
                    sx={{ ...f.sx, width: '100%' }}>
                    <Typography
                        sx={f.contentsx}
                        variant='h1'>
                        {f.title}
                    </Typography>
                </Box>
            </React.Fragment>
        )
    });

    const firstRow = [{
        title: 'CbCR and Pillar Two compliance',
        sx: { ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)' },
        contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'center', height: '0rem' }
    }]

    const secondRow = [{
        title: <ul>
            <li><a href='https://www.compareyourcountry.org/tax-cooperation/en/0/623/default'>Countries where MNEs submitted CbCR</a></li>
            <li><a href='https://web-archive.oecd.org/2022-09-12/422190-country-specific-information-on-country-by-country-reporting-implementation.htm'>CbCR reporting requirements & deadlines</a></li>
            <li><a href='https://web-archive.oecd.org/2022-09-12/422190-country-specific-information-on-country-by-country-reporting-implementation.htm'>Overview of reporting requirements per jurisdiction</a></li>
            <li><a href='https://www.oecd.org/en/topics/country-by-country-reporting-for-tax-purposes.html'>Countries that have signed up for CbCR</a></li>
        </ul>,
        sx: {
            ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)', paddingTop: '5rem', paddingBottom: '5rem',
            '& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
        },
        contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'left' }
    },
    {
        title: <ul>
            <li><a href='https://www.oecd.org/en/publications/tax-challenges-arising-from-digitalisation-of-the-economy-global-anti-base-erosion-model-rules-pillar-two_782bac33-en.html'>Model GloBE Rules</a></li>
            <li><a href='https://www.oecd.org/en/publications/tax-challenges-arising-from-the-digitalisation-of-the-economy-consolidated-commentary-to-the-global-anti-base-erosion-model-rules-2023_b849f926-en.html'>Commentary to the GloBE Rules</a></li>
            <li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/administrative-guidance-globe-rules-pillar-two-central-record-legislation-transitional-qualified-status.pdf'>Administrative Guidance</a></li>
            <li><a href='https://www.oecd.org/en/publications/2025/01/tax-challenges-arising-from-the-digitalisation-of-the-economy-globe-information-return-january-2025_b03274ed.html'>GloBE Information Return</a></li>
        </ul>,
        sx: {
            ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)', paddingTop: '5rem', paddingBottom: '5rem',
            '& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
        },
        contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'left' }
    }]

    const thirdRow = [{
        title: 'Anonymised analytics and insights',
        sx: { ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)' },
        contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', fontSize: '25px', display: 'flex', justifyContent: 'left', height: '0rem' }
    },
    {
        title: 'Resource centre',
        sx: { ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)' },
        contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', fontSize: '25px', display: 'flex', justifyContent: 'left', height: '0rem' }
    }]

    const fourthRow = [{
        title: <ul>
            <li><a href='https://www.oecd.org/content/dam/oecd/en/publications/reports/2023/11/corporate-tax-statistics-2023_068828ca/f1f07219-en.pdf'>OECD corporate tax statistics</a></li>
        </ul>,
        sx: {
            ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)', paddingTop: '4rem', paddingBottom: '4rem',
            '& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
        },
        contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', fontSize: '25px', display: 'flex', justifyContent: 'left' }
    },
    {
        title: <ul>
            <li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/safe-harbours-and-penalty-relief-global-anti-base-erosion-rules-pillar-two.pdf'>Safe harbours and penalty relief</a></li>
            <li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/tax-challenges-arising-from-the-digitalisation-of-the-economy-global-anti-erosion-model-rules-pillar-two-examples.pdf'>Illustrative examples</a></li>
            <li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/minimum-tax-implementation-handbook-pillar-two.pdf'>Implementation Handbook</a></li>
            <li><a href='https://www.oecd.org/en/topics/sub-issues/global-minimum-tax/global-anti-base-erosion-model-rules-pillar-two.html#background-material'>Background material</a></li>
        </ul>,
        sx: {
            ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)', paddingTop: '4rem', paddingBottom: '4rem',
            '& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
        },
        contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'left' }
    }]

    return (
        <React.Fragment>
            <Box className='container'>
                <Typography
                    sx={headerSX}
                    component='h3'>
                    <span style={{ color: '#ff5d00', justifyContent: 'space-between' }}>
                        Resources
                    </span>
                </Typography>
            </Box>
            <Box className='container' sx={{ flexDirection: 'column', gap: '1rem' }}>
                <Box sx={{ display: 'flex' }} style={{ display: 'flex', alignItems: 'center' }}>
                    {contentGenerator(firstRow)}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '2rem', alignItems: 'center' }}>
                    {contentGenerator(secondRow)}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '2rem', alignItems: 'center' }}>
                    {contentGenerator(thirdRow)}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '2rem', alignItems: 'center' }}>
                    {contentGenerator(fourthRow)}
                </Box>
            </Box>
        </React.Fragment>
    );
}

export default Resources;